// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__4ooCJ","content":"styles_content__2mx54","selectAll":"styles_selectAll__3BQL6"};